import React, {
  FC, useEffect, useState,
} from 'react';
import Header from '../Common/Header';
import ColumnCenter from '../../../components/Layout/ColumnCenter';
import FoodItem from './FoodItem';
import ResidentBtn from './ResidentBtn';
import CreateDriver from '../Role/Driver/CreateDriver';
import { Cab } from '../../../lib/types';
import SelectPlatform from '../Role/Driver/OpenBox/SelectPlatform';
import SelectPlatformReopen from '../Role/Driver/ReopenBox/SelectPlatform';
import Register from '../Role/User/Register';
import { getCabId, getWindowHeight, getWindowWidth, isMobile } from '../../../lib/utils/utils';
import Location from '../Common/Location';
import { getFoodifoxDataLazy } from '../../../lib/axios/FoodifoxDataAPI';
import SelectLocker from '../Role/SelectLocker';
import DownloadApp from '../Role/Driver/DownloadApp';
import RowCenter from '../../../components/Layout/RowCenter';
import Button from '../../../components/Button';
import InterMediumItalicText from '../../../components/Text/InterMediumItalicText';
import TermsConditionsModal from '../Common/TermsConditionsModal';
import Column from '../../../components/Layout/Column';
import Support from '../../V2/Support';
import AiModal from '../../V2/Common/AiModal';

const Home: FC<Props> = ({
  cabId32Str,
  deviceCode,
  cab,
  setCabData,
  ckFirebaseId,
  largeCabId,
  smallCabId,
  setShowLoading,
  setSmallCabId,
  setLargeCabId,
  setCabId32Str,
  setVersion,
}) => {
  const [getCabInfo, { loading }] = getFoodifoxDataLazy<Cab>('/foxH5Home/getCab');
  // 访问的页面
  const [targetPage, setTargetPage] = useState<string>();
  const [driverId, setDriverId] = useState<number>();
  const [isEnglish, setIsEnglish] = useState<boolean>(true);
  // 显示AI
  const [showAi, setShowAi] = useState<boolean>(false);
  // 验证的手机号，每次进入都需要验证
  const [aiPhoneNumber, setAiPhoneNumber] = useState<string>();
  // 是否跳转到选择柜子页面
  const [isToSelectLockerPage, setIsToSelectLockerPage] = useState<boolean>(false);
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (cabId32Str) {
      // 获取单个柜子信息
      getCabInfo({
        param: {
          cabId: cabId32Str,
        },
        onCompleted(data) {
          setCabData(data);
        },
      });
    }
  }, [cabId32Str]);

  useEffect(() => {
    setShowLoading(loading);

    return () => {
      setShowLoading(false);
    };
  }, [loading]);

  return (
    <>
      {
        showTermsModal && (
          <TermsConditionsModal
            callback={() => {
              setShowTermsModal(false);
            }}
            showAgreeBtn={false}
            showExitBtn={false}
            isEnglish={isEnglish}
          />
        )
      }
      {
        (targetPage == null || targetPage === 'home') && (
          <Column style={{ height: getWindowHeight(), alignItems: isMobile() ? undefined : 'center' }}>
            <div style={{ width: isMobile() ? undefined : 400 }}>
              {/* 头部 */}
              <Header
                style={{ marginTop: '20px' }}
                isEnglish={isEnglish}
                setIsEnglish={setIsEnglish}
                setTargetPage={setTargetPage}
                supportTextColor={'#00000080'}
                faqTextColor={'#00000080'}
                cabId32Str={cabId32Str}
                languageStyle={{ marginRight: 5 }}
              />

              {
                cab && (
                  <Location style={{ marginTop: 20 }} isEnglish={isEnglish} cab={cab} width={isMobile() ? getWindowWidth() - 40 : 400} contentWidth={isMobile() ? getWindowWidth() - 60 : 400} />
                )
              }

              <ColumnCenter style={{ marginTop: 30 }}>
                {/* 住户注册按钮 */}
                <ResidentBtn
                  cabId={getCabId(cabId32Str)}
                  isEnglish={isEnglish}
                  setTargetPage={(page) => {
                    if (cab) {
                      setTargetPage(page);
                    }
                    else {
                      setIsToSelectLockerPage(true);
                      setTargetPage(page);
                    }
                  }}
                />
                {/* 送餐入口 */}
                <FoodItem
                  setTargetPage={(page) => {
                    // if (cab) {
                    //   setTargetPage(page);
                    // }
                    // else {
                    //   setTargetPage('download-app');
                    // }
                    // 统一进入下载 App 页面
                    setTargetPage('download-app');
                  }}
                  isEnglish={isEnglish}
                  setDriverId={setDriverId}
                  cabId={getCabId(cabId32Str)}
                  cab={cab}
                  setSmallCabId={setSmallCabId}
                  setLargeCabId={setLargeCabId}
                />
              </ColumnCenter>
            </div>

            <RowCenter style={{ position: 'fixed', bottom: 0, paddingBottom: 10, paddingTop: 5, width: '100%', backgroundColor: '#FFFFFF' }}>
              <Button onClick={() => setShowTermsModal(true)}>
                <InterMediumItalicText fontSize={12} textDecorationLine={'underline'}>
                  Terms of use and Privacy Policy
                </InterMediumItalicText>
              </Button>
            </RowCenter>
          </Column>
        )
      }

      {
        // 跳转到选择柜子页面
        isToSelectLockerPage && (
          <SelectLocker
            targetPage={targetPage}
            setTargetPage={setTargetPage}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setCabData={setCabData}
            setIsToSelectLockerPage={setIsToSelectLockerPage}
          />
        )
      }

      {
        targetPage === 'download-app' && (
          <DownloadApp
            setTargetPage={setTargetPage}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
          />
        )
      }

      {
        targetPage === 'food-create-driver' && cab && (
          <CreateDriver
            cabId32Str={cabId32Str}
            deviceCode={deviceCode}
            onClose={() => {
              setTargetPage(undefined);
            }}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            cab={cab}
            setShowLoading={setShowLoading}
            setDriverId={setDriverId}
            setTargetPage={setTargetPage}
            ckFirebaseId={ckFirebaseId}
          />
        )
      }
      {
        targetPage === 'food-platform-select' && driverId && (
          <SelectPlatform
            cabId32Str={cabId32Str}
            onClose={() => {
              setTargetPage(undefined);
            }}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            driverId={driverId}
            smallCabId={smallCabId}
            largeCabId={largeCabId}
          />
        )
      }
      {
        targetPage === 'food-reopen-platform-select' && driverId && (
          <SelectPlatformReopen
            cabId32Str={cabId32Str}
            onClose={() => {
              setTargetPage(undefined);
            }}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            driverId={driverId}
          />
        )
      }
      {
        // 注册用户信息页面
        targetPage === 'register-parcel-user' && !isToSelectLockerPage && cab && (
          <Register
            onClose={() => {
              setTargetPage(undefined);
            }}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            cab={cab}
            setShowLoading={setShowLoading}
          />
        )
      }
      {/* 客服支持页面 */}
      {
        targetPage === 'support' && cab && (
          <Support
            cab={cab}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowAi={setShowAi}
            setTargetPage={setTargetPage}
            // 进入AI对话的用户手机号
            setAiPhoneNumber={setAiPhoneNumber}
          />
        )
      }
      {
        // AI 弹窗，需要验证手机号
        showAi && cab && aiPhoneNumber && (
          <AiModal
            setShowModal={setShowAi}
            setTargetPage={setTargetPage}
            setIsToSelectLockerPage={setIsToSelectLockerPage}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            cabId={cab.cabId}
            deviceCode={deviceCode}
            enterPhoneNumber={aiPhoneNumber}
          />
        )
      }
    </>
  );
};

export interface Props {
  cabId32Str: string;
  deviceCode: string;
  cab?: Cab;
  setCabData: (cabData?: Cab) => void;
  ckFirebaseId: string;
  // 大小柜组合时，小柜柜子ID和大柜柜子ID
  smallCabId?: number;
  largeCabId?: number;
  setShowLoading: (isShow: boolean) => void;
  setSmallCabId: (smallCabId?: number) => void;
  setLargeCabId: (largeCabId?: number) => void;
  setCabId32Str: (cabId32Str: string) => void;
  setVersion: (version?: string) => void;
}

export default Home;
